import { addNeiling, allNeilings, deleteNeiling, updateNeiling } from '@/utils/request'
import vue from '@/main'

const state = {
  neilingList: []
}

const mutations = {
  RESET (state) {
    state.neilingList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allNeilings().then(response => {
        state.neilingList = response.data
        resolve(state.neilingList)
      })
    })
  },
  neilingById ({ commit, state }, id) {
    for (const team of state.neilingList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, neiling) {
    return new Promise((resolve) => {
      updateNeiling(neiling).then(() => {
        for (const cur of state.neilingList) {
          if (cur.id === neiling.id) {
            Object.assign(cur, neiling)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, item) {
    return new Promise((resolve) => {
      addNeiling(item).then((response) => {
        state.neilingList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteNeiling(id).then(() => {
        for (const i in state.neilingList) {
          if (state.neilingList[i].id === id) {
            state.neilingList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
